<template>
    <div v-if=show>
        <div class="modal fade" :class="{ show: show }" tabindex="-1" role="dialog" aria-hidden="true" aria-labelledby="modalLabel">
            <div class="modal-dialog" role="document" :class="{'modal-dialog-centered' : centered}">
                <div class="modal-content" v-click-outside="closeModal">
                    <div class="modal-header d-flex flex-column">
                        <slot name="alert_message"></slot>
                        <h1 class="modal-title" id="modalLabel">{{title}}</h1>
                        <button type="button" data-dismiss="modal" class="btn btn--close btn--icon-only" @click="closeModal()">
                            <v-icon aria-hidden="true" focusable="false">mdi-close</v-icon>
                            <span class="sr-only">Fermer : {{title}}</span>
                        </button>         
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="show" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
export default{
    name: "Modal",

    props: {
        title:{
            type: String,
            default: ""
        },
        show:{
            type: Boolean,
            default: false
        },
        centered:{
            type: Boolean,
            default: true
        }
    },

    directives: {
        'click-outside':{
            bind(el, binding, vnode){
                el.eventSetDrag = function(){el.setAttribute('data-dragging', 'yes');}
                el.eventClearDrag = function(){el.removeAttribute('data-dragging');}
                el.eventOnClick = function(event){
                    let dragging = el.getAttribute('data-dragging');
                    // Check that the click was outside the el and its children, and wasn't a drag
                    if (!(el == event.target || el.contains(event.target)) && !dragging) {
                    // call method provided in attribute value
                        vnode.context[binding.expression](event);
                    }
                };
                document.addEventListener('touchstart', el.eventClearDrag);
                document.addEventListener('touchmove', el.eventSetDrag);
                document.addEventListener('click', el.eventOnClick);
                document.addEventListener('touchend', el.eventOnClick);
            },

            unbind(el){
                document.removeEventListener('touchstart', el.eventClearDrag);
                document.removeEventListener('touchmove', el.eventSetDrag);
                document.removeEventListener('click', el.eventOnClick);
                document.removeEventListener('touchend', el.eventOnClick);
                el.removeAttribute('data-dragging');
            }
        }
    },

    methods:{
        closeModal(){
            this.$emit('modal-closed');
        }
    }
}
</script>